<template>
  <div>
    <section>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px; padding-top: 10px; margin-bottom: -12px">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchText" placeholder="用户 / 账号 / 名称" clearable style="width:200px;"
              @keyup.enter.native="getList(1)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="typeValue" placeholder="类型" style="width: 120px" clearable>
              <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="typeValue2" placeholder="状态" style="width: 120px" clearable>
              <el-option v-for="item in types2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getProList(1)">查询</el-button>
          </el-form-item>

          <el-form-item>
            <el-button size="medium" :disabled="ProductSelection.length == 0 ? true : false"
              v-on:click="batch(1)">批量分配</el-button>
          </el-form-item>

          <el-form-item>
            <el-button size="medium" :disabled="ProductSelection.length == 0"
              @click="visibleDispatch = true">分配部门</el-button>
          </el-form-item>

        </el-form>
      </el-col>

      <!--列表-->
      <el-table ref="multipleTable" :data="proList" highlight-current-row v-loading="listLoading" style="width: 100%"
        :header-cell-style="getRowClass" @sort-change="handleSortChange"
        @selection-change="handleProductSelectionChange" :row-key="(row) => row.id">
        <el-table-column :reserve-selection="true" type="selection" width="55"> </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" min-width="200" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productname" label="名称" min-width="220" sortable="custom" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="name" label="用户" min-width="110" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.name || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="账号" min-width="120" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.phone || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="deptname" label="产品所属部门" min-width="120" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.deptname || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userdeptname" label="用户所属部门" min-width="120" sortable="custom" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.userdeptname || '-' }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="companyname" label="企业" min-width="160" sortable="custom" show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column prop="typename" label="类型" min-width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="usingstatusname" label="状态" min-width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="duetime1" label="到期时间" min-width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" min-width="120" style="text-algin: center">
          <template slot-scope="scope">
            <span class="operate">

              <el-tooltip effect="dark" content="分配用户授权" placement="top">
                <span class="dnnfont iconclone-more" @click="handleEdit(scope.$index, scope.row)"></span>
              </el-tooltip>

              <el-tooltip effect="dark" content="撤销用户授权" placement="top" v-if="!scope.row.delShow">
                <span class="dnnfont iconundo" @click="handleDel(scope.$index, scope.row)"></span>
              </el-tooltip>
              <!-- <span class="dnnfont iconundo icon-disabled" v-else  ></span> -->

              <el-tooltip effect="dark" content="撤销部门授权" placement="top" v-if="scope.row.deptid">
                <span class="dnnfont iconundo2" style="font-size: 17px"
                  @click="handleDelDepart(scope.$index, scope.row)"></span>
              </el-tooltip>
              <!-- <span class="dnnfont iconundo2 icon-disabled" v-else  ></span> -->
            </span>

            <!-- <el-button
              type="success"
              plain
              size="small"
              @click="handleEdit(scope.$index, scope.row)"
              >分配</el-button
            > -->
            <!-- <el-button
              type="danger"
              :disabled="scope.row.delShow"
              plain
              size="small"
              @click="handleDel(scope.$index, scope.row)"
              >撤销</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar" style="margin-top:10px; padding-bottom: 10px">
        <el-pagination layout="sizes, prev, pager, next" :page-sizes="[3, 10, 20, 30, 50, 100]"
          :current-page="pageNumber" @current-change="handleCurrentChange" @size-change="handleSizeChange"
          :page-size="pageSize" :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--分配界面-->
      <el-dialog class="model-edit" title="分配用户" v-if="editFormVisible" :visible.sync="editFormVisible"
        :close-on-click-modal="false">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
          <el-form :inline="true" :model="souchs2" @submit.native.prevent>


            <el-form-item>
              <el-select v-model="value2" placeholder="请选择" @change="changeSouch2" style="width: 120px">
                <el-option v-for="item in optionsSouch2" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-show="disSouch2" v-model="proName2" style="width: 200px"
                @keyup.enter.native="getUser(1)"></el-input>
              <el-select v-show="fpTypes2" v-model="fpType" placeholder="请选择" style="width: 200px" clearable>
                <el-option v-for="item in fpTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <!-- 选择部门 -->
              <el-select v-if="showDepart" v-model="deptid" placeholder="部门" style="width: 200px">
                <el-option v-for="item in departList" :key="item.id" :label="item.deptname" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="getUser(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <el-tag :key="tag2" v-for="tag2 in dynamicTags2" closable :disable-transitions="false"
            @close="handleClose2(tag2)">
            {{ tag2 }}
          </el-tag>
          <el-button v-if="dynamicTags2 != ''" class="button-new-tag" size="small" @click="delTags2">清除标签</el-button>
        </el-col>

        <!--用户列表-->
        <el-table :data="userList" highlight-current-row v-loading="userLoading" style="width: 100%" height='400'
          ref="userList" @select="selectTable" :row-key="(row) => row.id" :header-cell-style="getRowClass"
          @sort-change="handleSortChange2" @current-change="handleSelectionChange"
          @selection-change="handleUserSelectionChange">
          <el-table-column label="操作" width="80" v-if="batchType == 0">
            <template slot-scope="scope">
              <input type="checkbox" v-model="scope.row.checked" @change="changeFun" />
            </template>
          </el-table-column>
          <el-table-column v-else :reserve-selection="true" type="selection" width="55"> </el-table-column>
          <el-table-column prop="phone" label="账号" min-width="130" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="name" label="姓名" min-width="160" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="deptname" label="部门" min-width="200" sortable="deptname" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.deptname ? scope.row.deptname : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="invitestatusname" label="状态" min-width="180" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding:10px 0;">
          <el-pagination layout="total,sizes, prev, pager, next" :current-page="pageNumber2"
            @current-change="handleCurrentChange2" @size-change="handleSizeChange2" :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize2" :total="total2" style="float: right">
          </el-pagination>
        </el-col>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button v-if="batchType == 0" type="primary" @click.native="editSubmit(0)"
            :loading="editLoading">提交</el-button>
          <el-button v-if="batchType == 1" type="primary" @click.native="editSubmit(1)"
            :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--分配部门-->
      <el-dialog class="model-dispatch" title="分配部门" :visible.sync="visibleDispatch" :close-on-click-modal="false"
        :destroy-on-close="true" v-if="visibleDispatch">
        <el-row :gutter="20" style="margin-bottom: -10px;">
          <el-form :model="dispatchForm" :rules="dispatchRules" hide-required-asterisk label-position="left"
            ref="dispatchForm">
            <el-col :span="24" style="margin-bottom: 20px;color: #666; font-size: 14px;">
              已选择{{ ProductSelection.length }}个产品授权，请选择所属部门
            </el-col>
            <el-col :span="24">
              <el-form-item label=" " prop="deptid">
                <el-select v-model="dispatchForm.deptid" placeholder="请选择" style="width: 100%" clearable>
                  <el-option v-for="item in departList" :key="item.id" :label="item.deptname" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>

        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="handerCloseDispatch">取消</el-button>
          <el-button type="primary" @click.native="handerSubmitDispatch"
            :loading="confirmDispatchLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </div>
</template>
<script>
import { API__code, API_userCom } from '../../../api/index.js'
export default {
  inject: ['reload'],
  data() {
    return {
      ProductSelection: [], //勾选产品数组
      userSelection: [],
      disSouch2: true,
      fpTypes2: false,
      showDepart: false,//批量分配--选择部门
      fpType: '',
      dynamicTags2: [],
      souchs2: {},
      proName2: '',
      value2: '',
      deptid: '',//分配用户-部门id
      fpType2: '',
      optionsSouch2: [
        { value: '姓名', label: '姓名' },
        { value: '账号', label: '账号' },
        { value: '状态', label: '状态' },
        { value: '部门', label: '部门' },
      ],
      fpTypes: [
        { value: '1', label: '已有产品' },
        { value: '0', label: '未有产品' },
      ],

      disSouch: true,
      disType1: false,
      disType2: false,
      souchs: {
        id: '',
        phone: '',
        name: '',
        souType: '',
        status: '',
      },
      proName: '',
      value: '',
      types: [
        { value: '1', label: '试用' },
        { value: '2', label: '正式' },
      ],
      types2: [
        { value: '1', label: '正常使用' },
        // {value: '2',label: '到期'},
        { value: '3', label: '禁用' },
      ],
      typeValue: '',
      typeValue2: '',
      dynamicTags: [],

      token: '',
      checkCode: '',
      id: '',
      proList: [],
      listLoading: false,
      pageNumber: 1,
      pageSize: 20,
      total: 1,
      companymanageid: '',
      pageNumber2: 1,
      pageSize2: 10,
      total2: 1,
      userList: [],
      userLoading: false,
      editLoading: false,
      editFormVisible: false,
      rname: '',
      checkUserId: '',
      checkUserIdOld: '',
      flag: false,
      productid: '',
      orderType: '',
      orderStr: '',

      batchType: 0,
      searchText: '',

      // 分配部门
      visibleDispatch: false,
      dispatchForm: {
        deptid: '',
      },
      dispatchRules: {
        deptid: [{ required: true, message: '请选择部门', trigger: 'change' }],
      },
      confirmDispatchLoading: false,
      departList: [],

      deptpx: '',
      orderType: '',
    }
  },
  methods: {
    // 获取当前企业下的部门
    getDepartList() {
      let data = {
        token: this.token,
        companyid: this.$route.query.companyId,
      }
      API_userCom.getDepartList(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.departList = res.data.data || []
          } else {
            if (res.data.code == 403) {
              this.$router.push({ path: 'loginAdmin' })
            }
          }
        })
        .catch((err) => { })
    },

    // 分配部门
    handerSubmitDispatch() {
      this.$refs['dispatchForm'].validate((valid) => {
        if (valid) {
          this.confirmDispatchLoading = true
          let data = {
            auproductid: this.ProductSelection.join(),
            deptid: this.dispatchForm.deptid,
          }
          API_userCom.dispatchProductToDepart(data)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success('产品分配成功')
                this.handerCloseDispatch()
                this.getProList(1)
              } else {
                this.$message.error(res.data.message)
                if (res.data.code == 403) {
                  this.$router.push({ path: 'loginAdmin' })
                }
              }
              this.confirmDispatchLoading = false
            })
            .catch((err) => {
              this.confirmDispatchLoading = false
            })
        }
      })
    },

    handerCloseDispatch() {
      this.visibleDispatch = false
      this.$refs['dispatchForm'].resetFields()
    },

    selectTable(selection, row) {
      if (selection.length > this.ProductSelection.length) {
        let del_row = selection.shift()

        this.$refs.userList.toggleRowSelection(del_row, false)
      }
    },

    handleSortChange: function (val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx'
        } else if (val.prop == 'productname') {
          this.orderStr = 'productnamepx'
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx'
        } else if (val.prop == 'phone') {
          this.orderStr = 'phonepx'
        } else if (val.prop == 'duetime1') {
          this.orderStr = 'duetimepx'
        } else if (val.prop == 'typename') {
          this.orderStr = 'typepx'
        } else if (val.prop == 'usingstatusname') {
          this.orderStr = 'statuspx'
        } else if (val.prop == 'deptname') {
          this.orderStr = 'deptidpx'
        } else if(val.prop =='userdeptname'){
          this.orderStr='userdeptnamepx'
        }
        if (val.order == 'descending') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
      }
      this.getProList()
    },
    changeSouch2: function (val) {
      if (val == '姓名') {
        this.disSouch2 = true
        this.fpTypes2 = false
        this.showDepart = false
        this.proName2 = this.souchs2.name
      } else if (val == '账号') {
        this.disSouch2 = true
        this.fpTypes2 = false
        this.showDepart = false
        this.proName2 = this.souchs2.phone
      } else if (val == '状态') {
        this.disSouch2 = false
        this.showDepart = false
        this.fpTypes2 = true
      } else if (val == '部门') {
        this.disSouch2 = false
        this.fpTypes2 = false
        this.showDepart = true
      }
    },
    delTags2: function () {
      ; (this.souchs2 = {}), (this.value2 = '')
      this.fpType = ''
      this.proName2 = ''
      this.dynamicTags2 = []
      this.getUser()
    },
    handleClose2(tag) {
      if (tag == '姓名') {
        this.souchs2.name = ''
        if (this.value2 == '姓名') {
          this.proName2 = ''
        }
      }
      if (tag == '账号') {
        this.souchs2.phone = ''
        if (this.value2 == '账号') {
          this.proName2 = ''
        }
      }
      if (tag == '状态') {
        this.souchs2.fpType = ''
        this.fpType = ''
      }
      if (tag == '部门') {
        this.deptid = ''
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1)
    },

    delTags: function () {
      ; (this.souchs = {}), (this.souchs.souType = '')
      this.souchs.status = ''
      this.value = ''
      this.proName = ''
      this.typeValue = ''
      this.typeValue2 = ''
      this.dynamicTags = []
      this.getProList()
    },
    handleClose(tag) {
      if (tag == 'ID') {
        this.souchs.id = ''
        if (this.value == 'ID') {
          this.proName = ''
        }
      }
      if (tag == '用户') {
        this.souchs.name = ''
        if (this.value == '用户') {
          this.proName = ''
        }
      }
      if (tag == '账号') {
        this.souchs.phone = ''
        if (this.value == '账号') {
          this.proName = ''
        }
      }
      if (tag == '名称') {
        this.souchs.productname = ''
        if (this.value == '名称') {
          this.proName = ''
        }
      }
      if (tag == '类型') {
        this.souchs.souType = ''
        this.typeValue = ''
      }
      if (tag == '状态') {
        this.souchs.status = ''
        this.typeValue2 = ''
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    changeSouch: function (val) {
      if (val == '类型') {
        this.disSouch = false
        this.disType1 = true
        this.disType2 = false
        this.proName = ''
        this.typeValue = this.souchs.souType
      } else if (val == '状态') {
        this.disSouch = false
        this.disType1 = false
        this.disType2 = true
        this.proName = ''
        this.typeValue2 = this.souchs.status
      } else if (val == 'ID') {
        this.disSouch = true
        this.disType1 = false
        this.disType2 = false
        this.proName = this.souchs.id
      } else if (val == '账号') {
        this.disSouch = true
        this.disType1 = false
        this.disType2 = false
        this.proName = this.souchs.phone
      } else if (val == '用户') {
        this.disSouch = true
        this.disType1 = false
        this.disType2 = false
        this.proName = this.souchs.name
      } else if (val == '名称') {
        this.disSouch = true
        this.disType1 = false
        this.disType2 = false
        this.proName = this.souchs.productname
      }
    },
    editSubmit: function (type) {
      if (!this.checkUserId && type == 0) {
        this.$message.error('用户不可为空，请选择！')
        return
      }
      var methods = 'setProduct'
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        managerid: this.$route.query.managerId,
        productid: this.productid, //产品id
        userid: this.checkUserId, //用户id
      }
      if (type == 1) {
        methods = 'companyProductBatchDistribute'
        param['userid'] = this.userSelection + ''
        param['productid'] = this.ProductSelection + ''
      }
      this.editLoading = true
      API_userCom[methods](param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.$message({
              message: '分配完成',
              type: 'success',
              center: true,
            })
            this.editFormVisible = false
            this.getProList()
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'login' })
            }
          }
          this.editLoading = false
        })
        .catch((err) => {
          this.editLoading = false
          this.$message.error('数据丢失，试试重新登陆！')
        })
    },

    changeFun: function () {
      var falg = false
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].checked == true) {
          falg = true
          this.checkUserId = this.userList[i].id
        }
      }
      if (!falg) {
        this.checkUserId = ''
      }
    },

    handleProductSelectionChange(row) {
      var list = []
      if (row.length != 0) {
        row.map((item) => {
          list.push(item.id)
        })
      }
      this.ProductSelection = list
    },

    handleUserSelectionChange(row) {
      var list = []
      if (row.length != 0) {
        row.map((item) => {
          list.push(item.id)
        })
      }
      this.userSelection = list
    },

    handleSelectionChange(row) {
      if (this.batchType == 0) {
        this.flag = true
        if (row) {
          this.userList.forEach((item) => {
            if (item.id !== row.id) {
              item.checked = false
            }
            if (item.id == row.id) {
              item.checked = true
            }
          })
        } else {
          this.userList.forEach((item) => {
            item.checked = false
          })
        }

        if (row.name == null) {
          row.name = ''
        }
        if (row.phone == null) {
          row.phone = ''
        }
        this.checkUserId = row.id
        this.checkUserIdOld = row.id
      }
    },

    getUser: function (val) {
      if (this.value2 == '账号') {
        this.souchs2.phone = this.proName2
      }
      if (this.value2 == '姓名') {
        this.souchs2.name = this.proName2
      }
      if (this.value2 == '状态') {
        this.souchs2.fpType = this.fpType
      }
      var flag = true
      if (val == 1) {
        this.pageNumber2 = 1

        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag = false
              }
            }
          }
          if (flag) {
            this.dynamicTags2.push(this.value2)
          }
        }
      }

      let _this = this
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',
        companyid: this.$route.query.companyId,
        // companyid:this.companymanageid,
        phone: this.souchs2.phone,
        username: this.souchs2.name,
        hasproduct: this.souchs2.fpType,
        orderStr: this.deptpx,
        orderType: this.orderType,
        deptid: this.value2 == '部门' ? this.deptid : '' //部门id
      }
      this.userLoading = true
      API_userCom.userList(param)
        .then((res) => {
          this.userLoading = false
          if (res.data.code == API__code.SUCCESS) {
            if (res.data.data.list) {
              _this.userList = res.data.data.list
              for (var i = 0; i < res.data.data.list.length; i++) {
                if (res.data.data.list[i]) {
                  if (_this.rname && res.data.data.list[i].id == _this.rname) {
                    res.data.data.list[i].checked = true
                  } else {
                    res.data.data.list[i].checked = false
                  }
                }
              }
              if (res.data.data.totalRow) {
                _this.total2 = res.data.data.totalRow
              }
            }
          } else {
            this.userLoading = false
            _this.$message.error(res.data.message)
            if (res.data.code == 403) {
              _this.$router.push({ path: 'login' })
            }
          }
        })
        .catch((err) => {
          this.userLoading = false
          _this.$message.error('数据丢失，试试重新登陆！')
        })
    },

    handleDel: function (index, row) {
      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          let param = {
            token: this.token,
            checkCode: this.checkCode,
            // managerid:this.id,
            productid: row.id, //产品id
            // userid:null,//用户id
          }
          API_userCom.delProduct(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: '撤销成功',
                  type: 'success',
                  center: true,
                })
                this.getProList()
              } else {
                this.$message.error(res.data.message)
                if (res.data.code == 403) {
                  this.$router.push({ path: 'login' })
                }
              }
            })
            .catch((err) => {
              this.$message.error('数据丢失，试试重新登陆！')
            })
        })
        .catch((err) => { })
    },

    // 撤销部门授权
    handleDelDepart: function (index, row) {
      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          let param = {
            token: this.token,
            checkCode: this.checkCode,
            id: row.id, //产品id
          }
          API_userCom.delProductDepart(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({ message: '撤销成功', type: 'success', center: true })
                this.getProList()
              } else {
                this.$message.error(res.data.message)
                if (res.data.code == 403) {
                  this.$router.push({ path: 'login' })
                }
              }
            })
            .catch((err) => {
              this.$message.error('数据丢失，试试重新登陆！')
            })
        })
        .catch((err) => { })
    },

    handleEdit: function (index, row) {
      this.productid = row.id
      this.rname = ''
      this.rname = row.userid
      this.batchType = 0
      this.getUser()
      this.editFormVisible = true
    },
    batch() {
      this.productid = ''
      this.rname = ''
      this.getUser()
      this.batchType = 1
      this.editFormVisible = true
    },
    getProList: function (val) {
      if (this.value == 'ID') {
        this.souchs.id = this.proName
      }
      if (this.value == '账号') {
        this.souchs.phone = this.proName
      }
      if (this.value == '用户') {
        this.souchs.name = this.proName
      }
      if (this.value == '名称') {
        this.souchs.productname = this.proName
      }
      if (this.value == '类型') {
        this.souchs.souType = this.typeValue
      }
      if (this.value == '状态') {
        this.souchs.status = this.typeValue2
      }

      var flag = true
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value)
          }
        }
      }
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        companyid: this.$route.query.companyId,
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        productname: this.souchs.productname,
        // type: this.souchs.souType,
        type: this.typeValue,
        // status: this.souchs.status,
        status: this.typeValue2,
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText,
      }
      this.listLoading = true
      API_userCom.getList(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].userid) {
                res.data.data.list[i].delShow = false
              } else {
                res.data.data.list[i].delShow = true
              }
              if (res.data.data.list[i].duetime) {
                res.data.data.list[i].duetime1 = res.data.data.list[i].duetime.substring(0, 10)
              }
            }
            this.proList = res.data.data.list
            this.total = res.data.data.totalRow
          } else {
            this.$message.error(res.data.message)
            if (res.data.code == 403) {
              this.$router.push({ path: 'login' })
            }
          }
          this.listLoading = false
        })
        .catch((err) => {
          this.listLoading = false
          this.$message.error('数据丢失，试试重新登陆！')
        })
    },
    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return 'background:#F5F7FA'
      } else {
        return ''
      }
    },
    handleCurrentChange2(val) {
      this.pageNumber2 = val
      this.getUser()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.getUser()
    },
    handleSortChange2(val) {
      if (val.order == null) {
        //不排序
        this.deptpx = ''
        this.orderType = ''
        this.getUser()
      } else {
        var order
        if (val.order == 'descending') {
          order = 'desc'
        } else {
          order = 'asc'
        }
        this.deptpx = 'deptpx'
        this.orderType = order
        this.getUser()
      }
    },
    handleCurrentChange(val) {
      // this.ProductSelection.forEach(row => {
      //       this.$refs.multipleTable.toggleRowSelection(row);
      //     });
      this.pageNumber = val
      this.getProList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getProList()
    },

    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1]
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1]
          }
        }
      }
    },
  },
  created() {
    this.getCookie()
    this.getDepartList()
  },

  mounted() {
    this.getProList()
  },
}
</script>
<style scoped lang="scss">
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.float_left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// WeProduct.vue?7824c945